import { DatePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TruncatePipe } from '../../pipes/truncate-pipe';
import { RouterLink } from '@angular/router';
import { Api } from '../../services/api';
import { RecentArticleItems } from '../../interface/articles';
import { catchError, of, take, tap, timeout } from 'rxjs';

@Component({
  selector: 'app-widget-recents',
  imports: [
    RouterLink,
    TruncatePipe,
    NgxSkeletonLoaderModule
  ],
  templateUrl: './widget-recents.html',
  styleUrl: './widget-recents.css',
})
export class WidgetRecents {
  private api = inject(Api);
  isLoading = signal(false);
  articles = signal<RecentArticleItems[]>([]);

  private initialize() : void {
    this.isLoading.set(true);

    this.api.getWidgetRecentArticles()
    .pipe(
      take(1),
      timeout(10000),
      catchError(() => of([])),
      tap(() => this.isLoading.set(false))
    ).subscribe(arr => {
      this.articles.set(arr);
    });
  }

  ngOnInit() : void {
    this.initialize();
  }
}
